import { authClient, API } from "../index";

// Get all years
export const getYears = () => {
  return authClient().get(`${API}/year`);
};

// Get year by id
export const getYearById = (id) => {
  return authClient().get(`${API}/year/${id}`);
};

// Delete year
export const deleteYear = (id) => {
  return authClient().delete(`${API}/year/${id}`);
};

// Create year
export const postYear = (year) => {
  return authClient().post(`${API}/year`, year);
};

// Update year
export const updateYear = (id, year) => {
  return authClient().put(`${API}/year/${id}`, year);
};
